import cx from 'classnames'
import { ReactNode, useMemo } from 'react'
import { formatAggressorLLPrice } from '../../helpers/formatting'
import { SecurityModalInfo } from '../../store/windows/types'
import GenericDropdownMenu from '../GenericDropdownMenu/GenericDropdownMenu'

import styles from './modal.module.scss'

interface Props {
  currency: string
  isTreasury: boolean
  amountValueStyles?: string
  priceValueStyles?: string
  securityModalInfo: SecurityModalInfo
  selectedAccount?: string
  setMaxTradeAmt?: (newValue: string) => void
  maxDisabled?: boolean
  setSelectedAccount?: (st: string) => void
  tradeAmt: ReactNode
  updateOnChanges: Array<SecurityModalInfo[keyof SecurityModalInfo]>
}

const LeftInfoPanel = ({
  currency,
  isTreasury,
  amountValueStyles,
  priceValueStyles,
  securityModalInfo,
  selectedAccount,
  setSelectedAccount,
  setMaxTradeAmt,
  maxDisabled,
  tradeAmt,
  updateOnChanges
}: Props) => {
  const localSecurityModalInfo = useMemo(() => {
    return {
      ...securityModalInfo
    }
  }, [...updateOnChanges])
  const accountOptions = useMemo(
    () => Object.values(securityModalInfo.accountIdToName).sort(),
    [securityModalInfo]
  )
  // const isCancelled = securityModalInfo.orderStatus === 'Cancelled'
  const priceFieldStyles = cx(priceValueStyles, styles.value)
  const amountFieldStyles = cx(
    amountValueStyles,
    styles.value,
    styles.buySellColor,
    setMaxTradeAmt ? styles.amountBtn : styles.amountDisplay
  )

  return (
    <div className={styles.leftInfos}>
      <div className={styles.row}>
        <div>
          <label>Trade Amt</label>
          {tradeAmt}
        </div>
        <div>
          <p>Spread</p>
          <p className={styles.value}>{securityModalInfo.spread}</p>
        </div>
      </div>
      <div className={styles.row}>
        <div>
          <p className={styles.buySellColor}>Available Amt</p>
          <button
            type="button"
            data-testid="aggressor-amt"
            className={amountFieldStyles}
            title="Use max size as trade amount"
            onClick={() =>
              setMaxTradeAmt &&
              setMaxTradeAmt(securityModalInfo.maximumSize.toString())
            }
            disabled={maxDisabled}
          >
            {securityModalInfo.maximumSize.toLocaleString()}
          </button>
        </div>
        <div>
          <p>Price</p>
          <p data-testid="aggressor-price" className={priceFieldStyles}>
            {formatAggressorLLPrice(
              securityModalInfo.price,
              currency,
              isTreasury
            )}
          </p>
        </div>
      </div>
      <div className={styles.row}>
        <div>
          <p>*Bench Price</p>
          <p data-testid="aggressor-bench-price" className={styles.value}>
            {localSecurityModalInfo.benchmarkPrice}
          </p>
        </div>
        <div>
          <p>YTW</p>
          <p data-testid="aggressor-YTW" className={priceFieldStyles}>
            {localSecurityModalInfo.yieldToWorst}
          </p>
        </div>
      </div>
      <div className={styles.row}>
        <div>
          <p>Hedge Notional</p>
          <p data-testid="aggressor-hedge-notional" className={styles.value}>
            {securityModalInfo.hedgeNotional}
          </p>
        </div>
      </div>
      {selectedAccount && setSelectedAccount && (
        <div className={styles.accountLine}>
          Account:
          <GenericDropdownMenu
            selectedItem={selectedAccount}
            setSelectedItem={setSelectedAccount}
            options={accountOptions}
            selectId={''}
            openRight={true}
            testId="aggressor-account"
          />
        </div>
      )}
      <div className={styles.row}>
        <div className={styles.disclaimer}>
          <p>*Treasury execution/hedge may occur at a different price</p>
        </div>
      </div>
    </div>
  )
}

export default LeftInfoPanel
